import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import ResourceService from '@/services/httpTypescript/api/resource'
import type { ConsentName } from '@/types'
import { type Maybe, type ConsentsResponse } from '@/types'

const useResourceStore = defineStore('resource', () => {
  const consentsName = ref<ConsentName>('index_shop_consents')

  const {
    parsedData: consents,
    isLoading: consentsLoading,
    execute: fetchConsents
  } = ResourceService.getConsents(consentsName.value)

  const getConsents = computed<Maybe<ConsentsResponse>>(() => consents.value)

  const getConsentsLoader = computed<boolean>(() => consentsLoading.value)

  return {
    consents,
    getConsents,
    getConsentsLoader,
    fetchConsents
  }
})

export default useResourceStore
